import React, { useState } from 'react';
import './TagFields.css';
import { TagFieldConfig } from '../../enums/fieldTypes';
import { MdOutlineDelete, MdOutlineModeEdit } from 'react-icons/md';

export function TagFields({ fields, onRemove, onEdit, disabled, showDetails, ...props }) {
	if (!fields || fields.length === 0) {
		return (
			<div className="fields-list-container">
				<p className="empty-text">Nenhum campo criado.</p>
			</div>
		);
	}

	return (
		<div className='tag-fields'>
			{fields?.map((field, idx) => (
				<div className='tag-field'>
					<span>
						<span>
							{React.createElement(TagFieldConfig[field.type]?.icon, {
								color: TagFieldConfig[field.type]?.color,
								size: 22
							})}
							<span>{field.name}</span>
						</span>
						{showDetails && (
							<>
								<span>
									Obrigatório: {field.required ? 'Sim' : 'Não'}
								</span>
								<span>
									<span>Padrão:{' '}</span>
									{field.default ? (
										<span>{Array.isArray(field.default) ? field.default.join(', ') : field.default}</span>
									) : (
										<>Indefinido</>
									)}
								</span>
							</>
						)}
					</span>
					{props.showActions && (
						<div className='container-buttons' style={{ marginTop: 0 }}>
							<button
								type="button"
								className="btn-edit-tag-field-value"
								onClick={(e) => onEdit(idx)}
							>
								<MdOutlineModeEdit size={18} />
								Editar
							</button>
							<button
								type="button"
								className="btn-delete-tag-field-value"
								onClick={(e) => onRemove(idx)}
							>
								<MdOutlineDelete size={18} />
								Remover
							</button>
						</div>
					)}
				</div>
			))}
		</div>
	);
}